import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=771c58a2&scoped=true"
import script from "./TabView.vue?vue&type=script&lang=js"
export * from "./TabView.vue?vue&type=script&lang=js"
import style0 from "./TabView.vue?vue&type=style&index=0&id=771c58a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c58a2",
  null
  
)

export default component.exports